import { useMemo } from 'react'
import { LuCheck, LuX } from 'react-icons/lu'

import { FormFieldValidation } from '@/lib/core/interfaces/forms.types'
import { Loader } from '@/lib/core/components/Loader'
import { Wrapper } from '@/lib/core/components/ValidationBadge'

export type ValidationBadgeProps = {
  placement?: 'formControl'
  status: FormFieldValidation
}

export const ValidationBadge = ({ placement, status }: ValidationBadgeProps) => {
  const icon = useMemo(
    () => ({
      [FormFieldValidation.IDLE]: null,
      [FormFieldValidation.INVALID]: <LuX size="16" strokeWidth={1.5} />,
      [FormFieldValidation.VALID]: <LuCheck size="16" strokeWidth={1.5} />,
      [FormFieldValidation.VALIDATING]: <Loader />,
    }),
    [status],
  )

  return (
    <Wrapper $status={status} $placement={placement}>
      {icon[status]}
    </Wrapper>
  )
}
